export default class MapboxEvents {
  constructor({ main, opts }) {
    this._ = main;
    const { MapboxMap, mapboxConfiguration, mapboxModules } = opts;
    this.isDesktop = this._.sizes.isDesktop;
    this.mapboxConfiguration = mapboxConfiguration;
    this.mapboxModules = mapboxModules;
    // this.onClickMode = false;

    const map = MapboxMap.mapboxmap;

    this.hoveredFeature = {
      id: undefined,
      properties: {
        name: undefined,
      },
    };

    this.eventsType = {
      touchScrollEv: "ontouchstart" in window ? "touchstart" : "scroll",
      touchClickEv: "ontouchend" in window ? "touchstart" : "click",
    };
    this.tooltip = MapboxMap.tooltip;
    this.tooltip = MapboxMap.tooltip;
    this.map = map;

    // https://stackoverflow.com/a/33386309/4244812
    this.mousemove = this.mousemove.bind(this);
    this.mouseleave = this.mouseleave.bind(this);

    map.on("load", () => {
      this._.spinner && this._.spinner.loadingSpinner(true);
      this._.map.sourceLayerManager.loadSources();
    });

    map.on("render", (e) => {
      this._.map.spinner && this._.map.spinner.stopSpinner(e);
    });

    map.on("moveend", (e) => {
      if (this._.map.geoCoder.searchedLngLat) {
        const point = this._.map.mapboxmap.project(
          this._.map.geoCoder.searchedLngLat
        );
        e["point"] = point;

        const features = this._.map.mapboxmap.queryRenderedFeatures(point, {
          layers: [this.mapboxConfiguration.hoverLayer.id],
        });
        e["features"] = features;

        this.mousemove(e);
        this._.searchedLngLat = null;
      }

      // check if is over Canary Islands
      if (this._.map.controlCanaryIslands) {
        this._.map.controlCanaryIslands.checkIfMapsIsOverCanaryIslands(
          this._.map.mapboxmap
        );
      }
    });

    this.addButtonsEvents();

    this._.sizes.on("resize", () => {
      this.resize();
    });

    this.bindEvents();
  }

  resize() {
    this.eventsType = {
      touchScrollEv: "ontouchstart" in window ? "touchstart" : "scroll",
      touchClickEv: "ontouchend" in window ? "touchstart" : "click",
    };

    if (this.tooltip) {
      this.mouseleave();
    }
  }

  addButtonsEvents() {
    this._.el
      .querySelectorAll(".buttons-panel .g-btn-group button")
      .forEach((button) => {
        button.addEventListener(this.eventsType.touchClickEv, (e) => {
          e.preventDefault();
          this._.map.spinner.loadingSpinner(true);
          this.updateMap.call(this, button);
        });
      });
    if (this._.el.querySelector(".buttons-panel select")) {
      this._.el
        .querySelector(".buttons-panel select")
        .addEventListener("change", (e) => {
          e.preventDefault();
          this._.map.spinner.loadingSpinner(true);
          this.updateMap.call(this, e.target.value);
        });
    }
  }

  updateMap(button) {
    const activeFilter =
      button.dataset !== undefined ? button.dataset.value : button;
    this._.settings.set({ activeFilter: activeFilter });

    this.handleButtonsClasses(button);
    this._.map.sourceLayerManager.setLayer(activeFilter);

    if (this._.settings.get("createLegend")) {
      this._.legend.updateLegend(activeFilter);
    }

    // if (this.onClickMode === true) {
    //   this._.map.events.updateFeatureAppearance(this.hoveredFeature);
    //   this._.map.tooltip.mouseover();
    //   const d = this._data.get(this.hoveredFeature.id);
    //   if (d !== undefined) {
    //     this.tooltip.mouseenter(
    //       Object.assign({ name: this.hoveredFeature.properties.name }, d)
    //     );
    //     this.addTooltipCloseEvs();
    //   } else {
    //     this.mouseleave();
    //   }
    // }
  }

  handleButtonsClasses(button) {
    if (button && button.tagName === undefined) return;
    this._.el.querySelectorAll("button").forEach(function (el) {
      el.classList.remove("active");
    });
    if (button !== undefined) button.classList.add("active");
  }

  bindEvents() {}

  bindMapEvents() {
    const { fullScreen } = this._.settings.getSettings();
    if (this.isDesktop === true || fullScreen === false) {
      this.addRemoveMapEvents({ remove: true });
      this.addRemoveMapEvents({ add: true });
    }
    return this;
  }

  addRemoveMapEvents({ remove, add }) {
    const { mapboxmap } = this._.map;
    if (add === true) {
      mapboxmap
        // .on(
        //   "click",
        //   this.mapboxConfiguration.hoverLayer.id,
        //   this.mousemove,
        //   true
        // )
        .on(
          "mousemove",
          this.mapboxConfiguration.hoverLayer.id,
          this.mousemove,
          true
        )
        .on(
          "mouseleave",
          this.mapboxConfiguration.hoverLayer.id,
          // this.mouseleave.bind(this, "native"),
          this.mouseleave,
          true
        );
      mapboxmap.dragPan.enable();
      mapboxmap.touchZoomRotate.enable();
    } else if (remove === true) {
      mapboxmap
        .off(
          "mousemove",
          this.mapboxConfiguration.hoverLayer.id,
          this.mousemove,
          true
        )
        .off(
          "mouseleave",
          this.mapboxConfiguration.hoverLayer.id,
          this.mouseleave,
          true
        );
      mapboxmap.dragPan.disable();
      mapboxmap.touchZoomRotate.disable();
    }
    return this;
  }

  resetHoveredFeature() {
    this.hoveredFeature = {
      id: undefined,
      properties: {
        name: undefined,
      },
    };
  }

  mouseleave(native) {
    // 'native' exists when the user mouses-leaves the map, rather than when moving from one polygon to another
    this.tooltip.mouseleave();
    this.updateFeatureStroke(false);
    this.resetHoveredFeature();
    if (native !== undefined) {
      if (this._.settings.get("createLegend")) {
        this._.legend.updateLegend(this._.settings.get("activeFilter"), true);
      }
    }
  }

  updateFeatureStroke(hover) {
    if (this.hoveredFeature.id !== undefined) {
      this.map.setFeatureState(
        {
          source: this.mapboxConfiguration.fillLayer.source,
          sourceLayer: this.mapboxConfiguration.fillLayer.sourceLayer,
          id: this.hoveredFeature.id,
        },
        {
          hover,
        }
      );
    }
  }

  updateHoveredFeature(feature) {
    if (this.hoveredFeature.id) {
      this.hoveredFeature = null;
    }
    this.hoveredFeature = feature;
  }

  mouseover(feature) {
    this.updateFeatureStroke(false);
    this.updateHoveredFeature(feature);
    this.updateFeatureStroke(true);
  }

  // main method that is fired when user hovers the map
  mousemove(e) {
    if (e.features && e.features.length > 0) {
      const feature = e.features[0];
      const featureId = feature.id;
      if (this.hoveredFeature.id !== featureId) {
        this.mouseover(feature);

        const featureData = this._._data.get(featureId);
        this.tooltip.hover(featureId, featureData, this.hoveredFeature.id, e);
        if (this._.settings.get("createLegend")) {
          const activeFilter = this._.settings.get("activeFilter");
          this._.legend.updateLegend(activeFilter, false, featureData);
        }
      }
      // if (e.type === "click") {
      //   this.updateClickMode(true);
      //   this.addRemoveMapEvents({ remove: true });
      //   this._.map.mapboxmap.dragPan.enable();
      //   this._.map.mapboxmap.touchZoomRotate.enable();
      // }
    }
  }

  // addTooltipCloseEvs() {
  //   this._.map.tooltip.addCloseEvent(restoreEvents, this);

  //   function restoreEvents() {
  //     this.addRemoveMapEvents({ remove: true, add: true });
  //     this.mouseleave();
  //     // this.updateClickMode(false);
  //   }
  // }

  // updateClickMode(onClickMode) {
  //   if (onClickMode === true) {
  //     this._.map.tooltip.tooltipContent.classList.add("click-mode");
  //     this.addTooltipCloseEvs();
  //   } else {
  //     this._.map.tooltip.tooltipContent.classList.remove("click-mode");
  //     this.mouseleave();
  //   }
  //   this.onClickMode = onClickMode;
  // }
}
